import React from 'react'
import './QrTagSettingList.css'

type TagWithGroup = IQrTag & { group?: IGroup }

type Props = {
  qrTags: TagWithGroup[]
  loading: boolean
  error?: string | null
  onEdit: (qrTag: IQrTag) => void
}

const QrTagSettingList = ({
  qrTags,
  loading,
  error = null,
  onEdit,
}: Props) => {
  const statusMessage = (() => {
    if (loading) return 'QRタグを読み込み中...'
    if (error) return error
    return 'QRタグがありません。'
  })()

  return (
    <div className="qr-tag-settings-table">
      <table className="table">
        <thead className="header">
          <tr>
            <th><div className="title">タグ名</div></th>
            <th><div className="title">説明</div></th>
            <th><div className="title">QRコード番号</div></th>
            <th><div className="title">グループ</div></th>
            <th aria-label="操作"><div className="title" aria-hidden="true" /></th>
          </tr>
        </thead>
        <tbody className="list">
          {qrTags.length === 0 ? (
            <tr>
              <td className="list-row" colSpan={5}>{statusMessage}</td>
            </tr>
          ) : qrTags.map((qrTag) => (
            <tr key={qrTag.id} className="qr-tag-settings-table__row">
              <td className="qr-tag-settings-table__cell">
                <div className="qr-tag-settings-table__name">
                  {qrTag.name || '名称未設定'}
                </div>
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__description">
                {qrTag.description || '未設定'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__code">
                {qrTag.qr_code_info?.qr_code_number
                  || qrTag.qr_code_info?.digit_code
                  || '未設定'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__group">
                {qrTag.group?.name ?? '-'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__actions">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => onEdit(qrTag)}
                >
                  編集する
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default QrTagSettingList
